import { POST } from '../http_common';
import apiPaths from '../api_paths';

const generateUploadURL = ({ data, onSuccess = () => {}, onError = () => {} }) => {
  POST({
    data,
    path: apiPaths.GENERATE_UPLOAD_URL,
    onSuccess,
    onFailure: onError
  });
};

export default generateUploadURL;